// extracted by mini-css-extract-plugin
export default {"root":"FileCard_root__sVBwa","name":"FileCard_name__fDYpi","remove":"FileCard_remove__54cy1","disabled":"FileCard_disabled__QlJL2"};